import './shared/typography.scss';
import './shared/navigation.scss';
import './shared/card.scss';
import './bundles/styles.scss';
import Card from './shared/card';
Card();